<template>
  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
    <font-awesome-icon :icon="['fas', 'spinner']" spin v-if="caSaving"  size="6x"/>
    <div v-if="showSuccess" class="alert alert-success" role="alert">
      {{$t("Données correctement sauvées.")}}
    </div>
    <div v-if="showError" class="alert alert-warning" role="alert">
      {{$t(errorMessage)}}
    </div>
  <div action="#" class="row justify-content-center">
    <div class="col-sm-10 col-md-8">
      <div class="form-row">
        <div class="col-12 form-group">
          <input type="text" v-model="username" class="form-control" v-bind:placeholder="$t('login')" disabled>
        </div>
        <div class="col-12 form-group">
          <input type="text" v-model="surename" class="form-control" v-bind:placeholder="$t('Nom et Prénom')">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-model="company" v-bind:placeholder="$t('Société')">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-model="representants" v-bind:placeholder="$t('Représentant légal')">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Adresse')" v-model="address1">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Adresse 2')" v-model="address2">
        </div>
        <div class="col-7 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Ville')" v-model="locality">
        </div>
        <div class="col-5 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Code Postal')" v-model="postalCode">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Pays')" v-model="state">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Email')" v-model="email1">
        </div>
        <div class="col-12 form-group">
          <input type="text" class="form-control" v-bind:placeholder="$t('Phone')" v-model="phone">
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 text-center mt-2 mt-md-4">
    <button class="btn btn-primary ml-2" @click="save">{{$t('Valider')}}</button>
    <button class="btn btn-primary ml-2" @click="closeModifyCA">{{$t('Ecran précédent')}}</button>
  </div>
</div>
</template>

<script>
import { ref, toRefs  } from 'vue';
import i18n from '@/i18n';
export default {
  props: ['curUser'],
  setup(props, context) {
    const caSaving = ref(false);
    const errorMessage = ref('');
    const user = toRefs(props, 'curUser').curUser.value;
    const showSuccess = ref(false);
    const showError = ref(false);
    const username = ref(user.username);
    const surename = ref(user.sn);
    const company = ref(user.contact);
    const address1 = ref(user.cLigne1);
    const address2 = ref(user.cLigne2);
    const locality = ref(user.l);
    const state = ref(user.st);
    const postalCode = ref(user.postalCode);
    const email1 = ref(user.mail);
    const phone = ref(user.telephoneNumber);
    const representants = ref(user.representants);
    const closeModifyCA = function() {
      context.emit("closeModifyCA", {});
    }
    const validateEmail = function (email) {
      if (email.trim().length == 0) {
       return true;
      }
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
    const validatePhone = function (phone) {
      var re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\\./0-9]*$/;
      return re.test(phone);
    }
    const showErrorMessage = function(pError) {
      errorMessage.value = pError;
      showError.value = true;
      setTimeout(function () {
        showError.value = false;
      }, 5000); 
    }
    const validate = function() {
      if (!validatePhone(phone.value)) {
        showErrorMessage(("Le numéro de téléphone n'est pas correctement rempli."));
        return false;
      }
      if (!validateEmail(email1.value)) {
        showErrorMessage(("L'email semble ne pas être correct"));
        return false;
      }
      if (locality.value.length == 0) {
        showErrorMessage(("Veuillez renseigner une localité"));
        return false;
      }
      if (state.value.length == 0) {
        showErrorMessage(("Veuillez renseigner un pays"));
        return false;
      }
      if (postalCode.value.length == 0) {
        showErrorMessage(("Veuillez renseigner un code postal"));
        return false;
      }
      if (address1.value.length == 0) {
        showErrorMessage(("Veuillez renseigner une adresse"));
        return false;
      }
      if (surename.value.length == 0) {
        showErrorMessage(("Veuillez renseigner un nom"));
        return false;
      }
      return true;
    }
    const save = function() {
      if (!validate()) {
        return false;
      }
      let formData = new FormData();
      formData.append('lang', i18n.global.locale.value);
      formData.append('username', username.value);
      formData.append('sn', (surename.value === undefined) ? '' : surename.value);
      formData.append('contact', (company.value === undefined) ? '' : company.value);
      formData.append('representants', (representants.value === undefined) ? '' : representants.value);
      formData.append('cLigne1', (address1.value === undefined) ? '' : address1.value);
      formData.append('cLigne2', (address2.value === undefined) ? '' : address2.value);
      formData.append('l', (locality.value === undefined) ? '' : locality.value);
      formData.append('st', (state.value === undefined) ? 'LUXEMBOURG' : state.value);
      formData.append('postalCode', (postalCode.value === undefined) ? '' : postalCode.value);
      formData.append('mail', (email1.value === undefined) ? '' : email1.value);
      formData.append('telephoneNumber', (phone.value === undefined) ? '' : phone.value);
      caSaving.value = true;
      fetch("api/saveuserca", {
          body: formData,
          method: "post"
      }).then(function(resp) {
        resp.json().then(function(res) {
            caSaving.value = false;
            context.emit("refreshUserList", {});
            if ('success' in res) {
                if (res['success'] == true) {
                  showSuccess.value = true;
                  setTimeout(function () {
                    showSuccess.value = false;
                  }, 5000);
                } else {
                  showErrorMessage(("Une erreur est survenue lors de la sauvegarde de vos informations : ") + res['message']);
                }
            }
        }.bind(this));
      });
    }
   return {
      username,
      validatePhone,
      validateEmail,
      surename,
      company,
      address1,
      address2,
      locality,
      state,
      postalCode,
      email1,
      phone,
      representants,
      showSuccess,
      showError,
      errorMessage,
      save,
      closeModifyCA,
      caSaving
   }
  }
}
</script>

<style>

</style>